import { createApi } from "@reduxjs/toolkit/query/react";
import {
  baseQueryWithArgs,
  getQueryStringWithCreator,
} from "../utils/reduxHelper";
import { APIS_ENDPOINT } from "../utils/api_constants";

export const efficientReduxAPI = createApi({
  reducerPath: "efficientReduxAPI",
  baseQuery: baseQueryWithArgs,
  refetchOnFocus: true,
  tagTypes: ["Creator"],
  endpoints: (builder) => ({
    //GET Queries
    checkAuthStatusData: builder.query({
      refetchOnFocus: true,
      query: () => `c/checkAuthStatus`,
      extraOptions: { maxRetries: 5 },
    }),
    getCreatorConfig: builder.query({
      query: () =>
        getQueryStringWithCreator(
          APIS_ENDPOINT.getCreatorAuthorizations.getEndpoint()
        ),
      providesTags: ["CreatorConfig"],
      extraOptions: { maxRetries: 1 },
      transformResponse: (response) => {
        if (response?.success) {
          if (response.data.authenticated_creator_username)
            localStorage.setItem(
              "username",
              response.data.authenticated_creator_username
            );
          return response?.data;
        } else {
          return { error: response?.error };
        }
      },
      transformErrorResponse: (error) => {
        return error;
      },
    }),
    getInstagramStoriesTabStatus: builder.query({
      query: () => getQueryStringWithCreator("c/getInstagramStoriesTabStatus"),
      extraOptions: { maxRetries: 1 },
      transformResponse: (response) => {
        if (response?.success === true && response?.data) {
          return response.data;
        }
        return response?.data ?? response;
      },
    }),
  }),
});
export const {
  useCheckAuthStatusDataQuery,
  useGetCreatorConfigQuery,
  useLazyGetCreatorConfigQuery,
  useGetInstagramStoriesTabStatusQuery,
} = efficientReduxAPI;

export default efficientReduxAPI;
